import { useTranslation } from 'next-i18next'
import React from 'react'

import * as Belt from '@goodfellas/graduation'

import BeltSelect from '../belt/BeltSelect'

type BeltInputProps = {
  onChange: (belt: string) => void
  belt: string
  showFormLabel?: boolean
}

const BeltInput = ({ onChange, belt, showFormLabel = true }: BeltInputProps) => {
  const { t } = useTranslation('avaliacao360')

  const _handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value)
  }

  return (
    <div className="relative z-50 w-full mb-2 group">
      {showFormLabel && <label
        htmlFor="userBelt"
        className="block mb-2 text-xs uppercase text-white/70"
      >
        <strong>{t('identificatorBox.formLabels.belt')}</strong>
      </label>}
      <BeltSelect
        id="userBelt"
        name="userBelt"
        value={(belt as Belt.Colors) || ''}
        onChange={(color) => onChange(color)}
        labels={{
          choose: t('belts.choose')?.toString(),
          searchPlaceholder: t('belts.choose')?.toString(),
          white: t('belts.white')?.toString(),
          blue: t('belts.blue')?.toString(),
          purple: t('belts.purple')?.toString(),
          brown: t('belts.brown')?.toString(),
          black: t('belts.black')?.toString(),
          redBlack: t('belts.redBlack')?.toString(),
          redWhite: t('belts.redWhite')?.toString(),
          red: t('belts.red')?.toString(),
          gray: t('belts.gray')?.toString(),
          yellow: t('belts.yellow')?.toString(),
          orange: t('belts.orange')?.toString(),
          green: t('belts.green')?.toString(),
          juniorGroup: t('belts.juniorGroup', 'Infantil')?.toString(),
          adultGroup: 'Adulto',
          professionalGroup: 'Profissional',
        }}
      />
    </div>
  )
}

export default BeltInput
